import {
    ADMINGETMAPPINGBANKLIST_SUCCESS,
    ADMINGETMAPPINGBANKLIST_FAILED,
    RESET_ADMINGETMAPPINGBANKLIST,
    LOADING_ADMINGETMAPPINGBANKLIST,
    NETWORK_ERROR_ADMINGETMAPPINGBANKLIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADMINGETMAPPINGBANKLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case ADMINGETMAPPINGBANKLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case ADMINGETMAPPINGBANKLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_ADMINGETMAPPINGBANKLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_ADMINGETMAPPINGBANKLIST:
            return (state = initialState);
        default:
            return state;
    }
};